import React from 'react';
import { XIcon } from 'lucide-react';
import { Reveal } from './ui/Reveal';
import { painPoints, objections, PRODUCT } from '../data/content';
export function ProblemSection() {
  return <section aria-labelledby="problema" className="border-y border-line bg-canvasAlt" data-id="element-209" data-mp="30gxwg4089rpx">
      <div className="mx-auto max-w-page px-4 sm:px-6 lg:px-8 py-12 text-center" data-id="element-210" data-mp="2vpzcmug16bhx">
        <Reveal data-id="element-211" data-mp="39hvywhv0pr6e">
          <h2 id="problema" className="mx-auto max-w-3xl font-display text-2xl md:text-3xl font-bold uppercase leading-tight text-ink" data-id="element-212" data-mp="39hcr3tz30j63">
            Si alguna vez intentaste leer la Biblia, probablemente te pasó esto
          </h2>
          <ul className="mx-auto mt-6 grid max-w-4xl gap-2 sm:grid-cols-2" data-id="element-213" data-mp="3jdpmqxe6t73h">
            {painPoints.map(point => <li key={point} className="flex items-center justify-center gap-2.5 rounded-xl border border-line bg-surface px-4 py-3 text-sm md:text-base text-ink-muted" data-id="element-214" data-mp="1p1snwjdf0yye">
                <XIcon size={15} className="flex-shrink-0 text-danger" strokeWidth={2.5} data-id="element-215" data-mp="jdwmx3wkbyzj" />
                <span data-id="element-216" data-mp="o9tzr08man7k">{point}</span>
              </li>)}
          </ul>
          <p className="mx-auto mt-6 max-w-xl font-display text-lg md:text-xl font-bold leading-snug text-accent" data-id="element-217" data-mp="sci8z918tw52">
            “Quiero comprender mejor la Biblia… pero no sé cómo estudiarla.”
          </p>
        </Reveal>

        <Reveal delay={0.06} className="mx-auto mt-8 max-w-3xl rounded-2xl border border-line bg-surface p-6 md:p-8" data-id="element-218" data-mp="172pll84kkkxu">
          <h3 className="font-display text-xl md:text-2xl font-bold uppercase leading-tight text-ink" data-id="element-219" data-mp="1c33vywtn86z1">
            No necesitás estudiar teología para empezar
          </h3>
          <p className="mt-2 text-base text-ink-muted" data-id="element-220" data-mp="3dtnlxxmi0j1v">
            Muchas veces no te faltan ganas. Lo que te falta es:
          </p>
          <ul className="mt-4 flex flex-wrap justify-center gap-2" data-id="element-221" data-mp="3hv97e7d3m5no">
            {objections.map(obj => <li key={obj} className="rounded-full bg-gold-soft px-4 py-2 text-sm font-medium text-gold" data-id="element-222" data-mp="p0iqvejwtfk8">
                {obj}
              </li>)}
          </ul>
          <p className="mt-5 font-display text-lg font-bold text-ink" data-id="element-223" data-mp="xym4zpskfa20">
            Eso es lo que encontrás en {PRODUCT}
          </p>
          <p className="mx-auto mt-3 max-w-xl text-base text-ink-muted" data-id="element-224" data-mp="17ycypp9axl11">
            Un recorrido ordenado, con contexto y preguntas para reflexionar, y
            un método de aproximadamente 15 minutos que podés sostener día a
            día.
          </p>
        </Reveal>
      </div>
    </section>;
}